import * as Yup from 'yup';

import i18n from '@/i18n';

export const createUpdateDeviceSchema = Yup.object().shape({
  organizationIds: Yup.array()
    .min(1, i18n.t('organizationRequired', { ns: 'common' }))
    .required(i18n.t('organizationRequired', { ns: 'common' })),
  name: Yup.string()
    .required(i18n.t('nameRequired', { ns: 'common' }))
    .min(2, i18n.t('nameMin', { ns: 'common' }))
    .max(50, i18n.t('nameMax', { ns: 'common' })),
  hardwareId: Yup.string()
    .required(i18n.t('hardwareIdRequired', { ns: 'common' }))
    .min(2, i18n.t('nameMin', { ns: 'common' }))
    .max(50, i18n.t('nameMax', { ns: 'common' }))
});
